import * as Sentry from '@sentry/browser';
import * as Logger from '@navigator/frontend-logger';
import { router } from './service/router';
import {
  thirdPartySupportService,
  thirdPartyAppEvents,
  thirdPartyMediatorService
} from './third-party/service';
import './component/index';
import { setSentryPerformanceData, trackStartup } from './util';
import { initIacDispatcher } from './service/iac-dispatcher/iac-dispatcher'

if (Sentry && typeof Sentry.withScope === 'function' && typeof Sentry.captureMessage === 'function') {
  Logger.registerAppender(Logger.sentryAppender);
  setSentryPerformanceData();
  // initial readyState is 'interactive' but full performance data is only available after change to 'complete'
  document.addEventListener('readystatechange', setSentryPerformanceData);
}

const isDebugCookieSet = document.cookie.split(';').filter((item) => item.includes('navDebug=1')).length > 0;
Logger.setLogLevel(Logger.LogLevel.error); // TODO: Use environment to determine log level
if (isDebugCookieSet) {
  Logger.setLogLevel(Logger.LogLevel.debug);
}

thirdPartyMediatorService.init();
initIacDispatcher()

function startUp() {
  document.querySelectorAll('.accessibility').forEach((el) => {
    // use positioning instead of display:none to hide the block so screen readers will still announce it
    (el as HTMLElement).style.top = '-200px';
  });

  setTimeout(() => {
    router.navigateTo('');
  }, 0);

  trackStartup();
}

if (document.readyState !== 'loading') {
  startUp();
} else {
  document.addEventListener('DOMContentLoaded', startUp);
}

const removeShowListener = thirdPartySupportService.on(thirdPartyAppEvents.SHOW_BANNER, () => {
  removeShowListener();
  document.querySelector('nav-app-stack').classList.add('app-contents-wrapper--banner-displayed');
});
thirdPartySupportService.on(thirdPartyAppEvents.HIDE_BANNER, () => {
  document.querySelector('nav-app-stack').classList.remove('app-contents-wrapper--banner-displayed');
});
